import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { formatMoney, round10, sanitizeNumber } from '../../config/utils';
import { connect } from 'react-redux';
import { Results } from '../../components';

class Container extends Component {
  render() {
    return <Results {...this.props} />
  }
}

const mapStateToProps = state => {
  let { maxDrawDownEnhanced, maxDrawDownTraditional } = state.results.stats;
  let maxDrawdownDifference = maxDrawDownEnhanced - maxDrawDownTraditional;

  let { startingAmount, startingDate, stockAllocation, bitcoinPercentage, withRebalancing } = state.input;
  let baseUrl = `${window.location.origin}${window.location.pathname}`;
  let shareUrl = `${baseUrl}?startingAmount=${sanitizeNumber(startingAmount)}&startingDate=${startingDate.format('YYYY-MM-DD')}&stockAllocation=${stockAllocation}&bitcoinPercentage=${bitcoinPercentage}&withRebalancing=${withRebalancing ? 1 : 0}`;

  return {
    ...state.results.stats,
    startingDate: startingDate,
    maxDrawdownDifference: round10(maxDrawdownDifference, -2),
    shareUrl,
    handleCopy: (e) => {
      e.preventDefault();
      document.execCommand('copy');
    },
  }
}

const mapDispatchToProps = dispatch => {
  return {
  }
}

export const ResultsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Container);


// WEBPACK FOOTER //
// ./src/containers/Results/ResultsContainer.js